import { Box, Grid, Typography, Card } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import styles from './scMembers.module.scss';
import { CommonButton, CustomRequiredInputLabel, CustomTextFeild } from '../common/StyledComponents/StyledFields';
import NewSCMComponent from './newScm';
import UpdateScmStatusComponent from './updateScmStatus';
import { object, string, ValidationError } from "yup";
import { ClipLoader } from "react-spinners";
import { apiRequest, catchErrorMessageHandler } from '../../infrastructure/backendService';
import apiPath from "../../config/apiPaths.json";
import ErrorPopup from '../common/ErrorPopup';
import toast from "react-hot-toast";
import constants from "../../config/constants.json";
import AttendedScMeetingComponent from './attendedScMeetings';
import ScheduleSCMeetingsComponent from './scheduleSCMeetings';
import ScmReportsComponent from './scmReports';
import VolunteerManagement from './volunteerManagement';

interface ErrorMessageTypes {
  username: string;
  firstName: string;
  lastName: string;
  city: string;
  state: string;
  zipcode: string;
  phonenumber: string;
  email: string;
}

const ScMembersTabs = () => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const [searchButton, setSearchButton] = useState<boolean>(true);
  const [loading, setLoading] = useState(false);
  const [searchItems, setSearchItem] = useState([]);
  const [updateSearchItems, setUpdateSearchItem] = useState([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isNewScmParam, setIsNewScmParam] = useState<boolean>(false);
  const formFields = {
    username: "",
    firstName: "",
    lastName: "",
    city: "",
    state: "",
    zipcode: "",
    phonenumber: "",
    email: "",
  };
  const [formData, setFormData] = useState({ ...formFields });
  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({ ...formFields });
  const [pageSize, setPageSize] = useState<number>(20);
  const [showTableComponent, setShowTableComponent] = useState<boolean>(false);
  const prevPageNumber = usePrevious(pageNumber);

  
  function usePrevious(value: any) {
    const ref = useRef();

    useEffect(() => {
      ref.current = value;
    }, [value]); // Only re-run if value changes

    return ref.current; // Return previous value (before update)
  }

  useEffect(() => {
    // Check if previous values are not undefined to ensure this is not the first render
    // And then check if the current values differ from the previous ones
    if ((prevPageNumber !== undefined && prevPageNumber !== pageNumber)) {
      searchDataApi();
    }
  }, [pageNumber, prevPageNumber, pageSize, isNewScmParam]);

  const didMountRef = useRef(false);

  useEffect(() => {
    // This block will execute when component updates
    if (didMountRef.current) {
      // Your code for componentDidUpdate
      !searchButton && handleSearch();
    } else {
      // This block will execute only on initial mounting
      didMountRef.current = true;
    }
  }, [isNewScmParam]);

  const validationSchema = object().shape({
    // username: string().required("Sign name is required"),
    // firstName: string().required("First Name is required"),
    // lastName: string().required("Last Name is required"),
    // city: string().required("City is required"),
    // state: string().required("State is required"),
    // zipcode: string().required("Zipcode is required"),
    // phonenumber: string().required("Phone Number is required"),
    // email: string()
    //   .email("Invalid email address")
    //   .required("Email is required"),
  });

  const handleSearch = async () => {
    const errors: ErrorMessageTypes = {
      username: "",
      firstName: "",
      lastName: "",
      city: "",
      state: "",
      zipcode: "",
      phonenumber: "",
      email: "",
    };
    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);

      // Call your API or perform other actions here
      searchDataApi();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  const searchDataApi = () => {
    setSearchItem([]);
    setShowTableComponent(false);
    const reqBody = {
      username: formData.username,
      firstname: formData.firstName,
      lastname: formData.lastName,
      city: formData.city,
      state: formData.state,
      zipcode: formData.zipcode,
      sortBy: formData.username,
      phoneNumber: formData.phonenumber,
      email: formData.email,
    };
    setLoading(true);
    const scmParam = activeTab === 0 ? false : true;
    apiRequest({
      method: "POST",
      endpoint: apiPath.scmSearchApi,
      body: JSON.stringify(reqBody),
      includeToken: true,
      params: {
        page: pageNumber - 1,
        size: 20,
        scm: scmParam,
        newScmRecords:isNewScmParam
      },
    })
      .then((res) => {
        setLoading(false);
        setTotalRecords(res.data.totalElements);
        setShowTableComponent(true);

        if (res.data.content.length === 0) {
          setSearchItem([]);
          setUpdateSearchItem([]);
        } else {
          setSearchItem(res.data.content);
          setUpdateSearchItem(res.data.content);
          setErrorMessage({ ...errorMessage, username: "" });
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };

  const zipCodeApi = () => {
    if (formData.zipcode !== "") {
      apiRequest({
        method: "GET",
        endpoint: apiPath.cityAndStateApi,
        params: {
          zip: formData.zipcode,
        },
      })
        .then((res) => {
          setErrorMessage({
            ...errorMessage,
            zipcode: "",
          });
          setFormData({
            ...formData,
            state: res.data.stateName,
            city: res.data.city,
          });
        })
        .catch((err) => {
          console.log(err);

          setErrorMessage({
            ...errorMessage,
            zipcode: catchErrorMessageHandler(err),
          });
          setFormData({
            ...formData,
            state: "",
            city: "",
          });
        });
    }
  };

  const handleTabClick = (tabIndex: number, toogle: boolean) => {
    setActiveTab(tabIndex);
    setFormData({ ...formFields });
    setSearchButton(true);
    setSearchItem([]);
    setUpdateSearchItem([]);
    setShowTableComponent(false);
  };

  const handleFieldChange = (field: string, value: any) => {
     setPageNumber(1);
    if (formData != null) {
      setSearchButton(false);
    } else {
      setSearchButton(true);
    }
    setFormData({
      ...formData,
      [field]: value,
    });
  };

 
  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <NewSCMComponent searchItems={searchItems} totalRecords={totalRecords} pageNumber={pageNumber} setPageNumber={setPageNumber} searchDataApi={searchDataApi}
        setIsNewScmParam={setIsNewScmParam} showTableComponent={showTableComponent}/>;
      case 1:
        return <UpdateScmStatusComponent updateSearchItems={updateSearchItems} totalRecords={totalRecords} pageNumber={pageNumber} setPageNumber={setPageNumber} searchDataApi={searchDataApi}
        showTableComponent={showTableComponent} />;
      case 2:
        return <AttendedScMeetingComponent />;
      case 3:
        return <ScheduleSCMeetingsComponent />;
      // case 4:
      //   return <VolunteerManagement />;
      case 5:
        return <ScmReportsComponent />;
      default:
        return null;
    }
  };

  const searchFieldsContainer = () => {
    return (
      <form className={styles.SearchContainer} autoComplete="off" onSubmit={handleSearch}>
        <Box className={styles.formContainer} >
          <Card className={styles.cardContainer}>
            <div>
              <Grid container spacing={2}>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("Username", false)}
                  <CustomTextFeild
                    id="signInName"
                    fullWidth
                    required
                    value={formData.username}
                    onChange={(e) => {
                      handleFieldChange("username", e.target.value);
                      setErrorMessage({ ...errorMessage, username: "" });
                    }}
                    className={
                      errorMessage.username
                        ? styles.errorTextField
                        : styles.textField
                    }
                    onBlur={() => {
                      const inputUserName = formData.username.toUpperCase();
                      handleFieldChange('username', inputUserName);
                    }}
                  // onKeyDown={(e) => handleKeyDownuser(e, "username")}
                  />
                  {errorMessage.username ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.username}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("First Name", false)}
                  <CustomTextFeild
                    id="firstName"
                    fullWidth
                    required
                    value={formData.firstName}
                    onChange={(e) => {
                      handleFieldChange("firstName", e.target.value);
                      setErrorMessage({ ...errorMessage, firstName: "" });
                    }}
                    // onKeyDown={(e) => handleKeyDown(e, "firstName")}
                    className={
                      errorMessage.firstName
                        ? styles.errorTextField
                        : styles.textField
                    }
                  />
                  {errorMessage.firstName ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.firstName}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("Last Name", false)}
                  <CustomTextFeild
                    id="lastName"
                    fullWidth
                    required
                    value={formData.lastName}
                    onChange={(e) => {
                      handleFieldChange("lastName", e.target.value);
                      setErrorMessage({ ...errorMessage, lastName: "" });
                    }}
                    // onKeyDown={(e) => handleKeyDown(e, "lastName")}
                    className={
                      errorMessage.lastName
                        ? styles.errorTextField
                        : styles.textField
                    }
                  />
                  {errorMessage.lastName ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.lastName}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("Zip Code", false)}
                  <CustomTextFeild
                    id="zipCode"
                    fullWidth
                    required
                    value={formData.zipcode}
                    onChange={(e) => {
                      const inputNumber = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                      const slicedNumber = inputNumber.slice(0, 10); // Limit to 10 digits
                      handleFieldChange("zipcode", slicedNumber);
                      setErrorMessage({ ...errorMessage, zipcode: "" });
                    }}
                    onBlur={zipCodeApi}
                    className={
                      errorMessage.zipcode
                        ? styles.errorTextField
                        : styles.textField
                    }
                  />
                  {errorMessage.zipcode ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.zipcode}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("City", false)}
                  <CustomTextFeild
                    id="city"
                    fullWidth
                    required
                    onChange={(e) => {
                      handleFieldChange("city", e.target.value);
                      setErrorMessage({ ...errorMessage, city: "" });
                    }}
                    value={formData.city}
                    InputProps={{
                      readOnly: true,
                    }}
                    className={
                      errorMessage.city ? styles.errorTextField : styles.textField
                    }
                  />
                  {errorMessage.city ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.city}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("State", false)}
                  <CustomTextFeild
                    id="state"
                    fullWidth
                    required
                    onChange={(e) => {
                      handleFieldChange("state", e.target.value);
                      setErrorMessage({ ...errorMessage, state: "" });
                    }}
                    value={formData.state}
                    InputProps={{
                      readOnly: true,
                    }}
                    className={
                      errorMessage.state
                        ? styles.errorTextField
                        : styles.textField
                    }
                  />
                  {errorMessage.state ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.state}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("Phone Number", false)}
                  <CustomTextFeild
                    id="phoneNumber"
                    fullWidth
                    value={formData.phonenumber}
                    onChange={(e) => {
                      const inputNumber = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                      const slicedNumber = inputNumber.slice(0, 10); // Limit to 10 digits
                      handleFieldChange("phonenumber", slicedNumber);
                      setErrorMessage({ ...errorMessage, phonenumber: "" });
                    }}
                    className={
                      errorMessage.phonenumber
                        ? styles.errorTextField
                        : styles.textField
                    }
                  />
                  {errorMessage.phonenumber ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.phonenumber}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("Email ID", false)}
                  <CustomTextFeild
                    id="email"
                    fullWidth
                    required
                    value={formData.email}
                    onChange={(e) => {
                      handleFieldChange("email", e.target.value);
                      setErrorMessage({ ...errorMessage, email: "" });
                    }}
                    className={
                      errorMessage.email
                        ? styles.errorTextField
                        : styles.textField
                    }
                  />
                  {errorMessage.email ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.email}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
            </div>
          </Card>
        </Box>
        <Box>
          <Grid xs={12} item>
            <CommonButton
              className={styles.search}
              onClick={handleSearch}
              disabled={searchButton || loading}
              id="search"
              type="submit"
            >
              {loading ? (
                <>
                  <ClipLoader color="#fff" loading={loading} size={15} />
                  <span
                    style={{
                      marginLeft: "8px",
                      fontSize: "15px",
                      textAlign: "center",
                    }}
                  >
                    Loading...
                  </span>
                </>
              ) : (
                "Search"
              )}
            </CommonButton>
          </Grid>
        </Box>
      </form>
    )
  }


  return (
    <Box className={styles.scMembersMainContainer}>
      <Grid className={styles.scMembersHeading}>
        <Typography className={styles.typoGraphyHeading}>SC Members Management</Typography>
      </Grid>
      <Grid className={styles.tabsContainer}>
        <Typography className={`${styles.tab} ${activeTab === 0 ? `${styles.active}` : ''}`} onClick={() => handleTabClick(0, true)}>
          New SCM
        </Typography>
        <Typography className={`${styles.tab} ${activeTab === 1 ? `${styles.active}` : ''}`} onClick={() => handleTabClick(1, false)}>
          Update SCM Status
        </Typography>
        <Typography className={`${styles.tab} ${activeTab === 2 ? `${styles.active}` : ''}`} onClick={() => handleTabClick(2, false)}>
          Attended SC Meetings
        </Typography>
        <Typography className={`${styles.tab} ${activeTab === 3 ? `${styles.active}` : ''}`} onClick={() => handleTabClick(3, false)}>
          Schedule SC Meetings
        </Typography>
        {/* <Typography className={`${styles.tab} ${activeTab === 4 ? `${styles.active}` : ''}`} onClick={() => handleTabClick(4, false)}>
          Volunteer Management
        </Typography> */}
        <Typography className={`${styles.tab} ${activeTab === 5 ? `${styles.active}` : ''}`} onClick={() => handleTabClick(5, false)}>
          SCM Reports
        </Typography>
      </Grid>
      <Grid>
        {(activeTab !== 2 && activeTab !== 3 && activeTab !== 5) && searchFieldsContainer()}
        {renderTabContent()}
      </Grid>
    </Box>
  )
}

export default ScMembersTabs